import { useEffect, useState } from "react";

type UseCountDownProps = {
	countFrom: number;
	countTo?: number;
	onTimesUp?: () => void;
};

export function useCountDown(props: Readonly<UseCountDownProps>) {
	const { countFrom, onTimesUp, countTo = 0 } = props;
	const [counter, setCounter] = useState(countFrom);

	useEffect(() => {
		if (counter > countTo) {
			const intervalId = setInterval(() => {
				setCounter((prevCounter) => prevCounter - 1);
			}, 1000);

			return () => clearInterval(intervalId);
		} else {
			return onTimesUp?.();
		}
	}, [counter]);

	return { counter, isFinished: counter === countTo };
}
